import { render, staticRenderFns } from "./SomeoneAsLonelyAsYou.vue?vue&type=template&id=5371eb88&scoped=true&lang=pug&"
import script from "./SomeoneAsLonelyAsYou.vue?vue&type=script&lang=js&"
export * from "./SomeoneAsLonelyAsYou.vue?vue&type=script&lang=js&"
import style0 from "./SomeoneAsLonelyAsYou.vue?vue&type=style&index=0&id=5371eb88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5371eb88",
  null
  
)

export default component.exports